export default a => (a || '').split(/[./]/g).pop();



// WEBPACK FOOTER //
// ./client/helpers/short-name.js